import styled from 'styled-components'

type Props = {
	limitHeight: boolean
	colorScheme: 'light' | 'dark'
}

export const Container = styled.div<Props>`
	position: relative;

	*::-webkit-scrollbar-thumb {
		background-color: ${({ colorScheme }) => (colorScheme === 'light' ? '#ADB1B2' : '#6f9b8f')};
	}

	> pre {
		max-height: ${({ limitHeight }) => limitHeight && '418px'};
	}

	> pre > code {
		margin: 0;
		padding: 0;
	}
`
